import _ from "lodash";

export const createSimpleListActions = prefix => ({
  ACCESS: `${prefix}`,
  PICK: `${prefix}--PICK`,
  RESET: `${prefix}--RESET`,
  TOGGLE: `${prefix}--TOGGLE`
});
export const asListReducer = (updateAction, listName) => (
  state = { [listName]: [] },
  action
) => {
  switch (action.type) {
    case updateAction.PICK: // pass in whole list
      return { [listName]: action.data };
    case updateAction.TOGGLE: // toggle single item within list
      const value = action.data;
      const newList = [...state[listName]];
      const serial = value instanceof Object ? value : value.toString();
      if (newList.find(item => _.isEqual(item, serial))) {
        newList.splice(newList.indexOf(serial), 1);
      } else {
        newList.push(serial);
      }
      return { [listName]: newList };
    case updateAction.RESET:
      return { [listName]: [] };
    default:
      return state;
  }
};

export const createGetActions = base => ({
  CACHED: base + "_CACHED",
  LOADING: base + "_LOADING",
  SUCCESS: base + "_SUCCESS",
  FAILURE: base + "_FAILURE",
  UPDATED: base + "_UPDATED",
  UPDATED_ALL: base + "_UPDATED_ALL",
  RESET: base + "_RESET",
  HASH: base + "_HASH"
});

export const createFetchingReducer = (
  resourceActionTypes,
  initialStates,
  resourceName
) => (
  state = { ...initialStates, loading: false, success: false, errors: null },
  action
) => {
  switch (action.type) {
    case resourceActionTypes.RESET:
      return { ...initialStates, loading: false, success: false, errors: null };
    case resourceActionTypes.CACHED:
      return state;
    case resourceActionTypes.LOADING:
      return { ...state, loading: true, success: false, errors: null };
    case resourceActionTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        errors: null,
        ...action.payload
      };
    case resourceActionTypes.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        errors: action.payload
      };
    case resourceActionTypes.UPDATED:
      return {
        ...state,
        loading: false,
        success: true,
        errors: null,
        [resourceName]: { ...state[resourceName], ...action.data }
      };
    case resourceActionTypes.UPDATED_ALL:
      return {
        ...state,
        loading: false,
        success: true,
        errors: null,
        ...action.data
      };
    default:
      return state;
  }
};
